<template>
  <fieldset class="form-checkboxes-double-col-wrapper">
    <p>{{ i18nDescription }}</p>

    <div
      :class="
        'form-checkboxes-double-col ' +
          (showDayOptionsAsCurrentFutureCols ? '' : 'form-checkboxes-double-col--prevent-col')
      "
    >
      <div class="form-checkboxes-double-col__col form-checkboxes-double-col__col--wide">
        <div class="form-checkboxes-double-col__header-wrapper">
          <span class="form-checkboxes-double-col__header">{{ i18n.form.labels.day }}</span>
          <span class="form-checkboxes-double-col__header text-center">{{
            i18n.form.labels.currentSituation
          }}</span>
        </div>

        <FormulateInput
          v-model="currentDayParts"
          :name="namePrefix + 'CurrentDayParts'"
          :options="inputOptions"
          type="checkbox"
          @input="handleInputForDayPartSelection"
        />
      </div>
      <div class="form-checkboxes-double-col__col">
        <div class="form-checkboxes-double-col__header-wrapper">
          <arrow-right-white
            class="form-checkboxes-double-col__arrow icon"
          />
          <span class="form-checkboxes-double-col__header text-center">{{
            i18n.form.labels.futureSituation
          }}</span>
        </div>
        <FormulateInput
          v-model="futureDayParts"
          :name="namePrefix + 'FutureDayParts'"
          :class="showDayOptionsAsCurrentFutureCols ? '' : 'two-column-options'"
          :options="inputOptions"
          type="checkbox"
          :help="i18n.form.help.dayparts"
          :validation="!isCancellationSelected ? 'required' : ''"
          :validation-messages="i18n.form.validations.dayparts"
          @input="handleInputForDayPartSelection"
        />
      </div>
    </div>

    <FormulateInput
      v-if="showCancellation"
      v-model="isCancellationSelected"
      :name="namePrefix + 'Cancellation'"
      :label="i18nCancellation"
      type="checkbox"
      @input="handleInputForCancellation"
    />
  </fieldset>
</template>

<script>
export default {
  name: 'FieldsProductsDayParts',
  components: {
    ArrowRightWhite: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ArrowRightWhite.vue'),
  },
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    i18nDescription: {
      type: String,
      default: () => '',
    },
    i18nCancellation: {
      type: String,
      default: () => '',
    },
    namePrefix: {
      type: String,
      default: () => '',
    },
    showCancellation: {
      type: Boolean,
      default: false,
    },
    showDayOptionsAsCurrentFutureCols: {
      type: Boolean,
      default: true,
    },
  },
  data: function() {
    return {
      currentDayParts: [],
      futureDayParts: [],
      isCancellationSelected: false,
      daysFieldIsRequired: true,
    };
  },
  computed: {
    inputOptions() {
      return {
        mondaymorning: `${this.i18n.form.labels.daysoptions.monday}${this.i18n.form.labels.daypartsoptions.morning}`,
        mondayafternoon: `${this.i18n.form.labels.daysoptions.monday}${this.i18n.form.labels.daypartsoptions.afternoon}`,
        tuesdaymorning: `${this.i18n.form.labels.daysoptions.tuesday}${this.i18n.form.labels.daypartsoptions.morning}`,
        tuesdayafternoon: `${this.i18n.form.labels.daysoptions.tuesday}${this.i18n.form.labels.daypartsoptions.afternoon}`,
        wednesdaymorning: `${this.i18n.form.labels.daysoptions.wednesday}${this.i18n.form.labels.daypartsoptions.morning}`,
        wednesdayafternoon: `${this.i18n.form.labels.daysoptions.wednesday}${this.i18n.form.labels.daypartsoptions.afternoon}`,
        thursdaymorning: `${this.i18n.form.labels.daysoptions.thursday}${this.i18n.form.labels.daypartsoptions.morning}`,
        thursdayafternoon: `${this.i18n.form.labels.daysoptions.thursday}${this.i18n.form.labels.daypartsoptions.afternoon}`,
        fridaymorning: `${this.i18n.form.labels.daysoptions.friday}${this.i18n.form.labels.daypartsoptions.morning}`,
        fridayafternoon: `${this.i18n.form.labels.daysoptions.friday}${this.i18n.form.labels.daypartsoptions.afternoon}`,
      };
    },
  },
  methods: {
    handleInputForDayPartSelection(dayParts) {
      this.isCancellationSelected = false;
      this.sortSelectedDayPartsChronologically(dayParts);
    },
    handleInputForCancellation(value) {
      if (value) {
        this.futureDayParts.splice(0, this.futureDayParts.length);
      }
    },
    sortSelectedDayPartsChronologically(dayParts) {
      if (dayParts) {
        const allDayParts = Object.keys(this.inputOptions);
        dayParts.sort((a, b) => allDayParts.indexOf(a) - allDayParts.indexOf(b));
      }
    },
  },
};
</script>
